import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'arrowCircle',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-arrow-circle wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g class="wd-icon-container"><g><path d="M14.453 12.051 13 10.598V16.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-5.902l-1.453 1.453a.495.495 0 0 1-.701 0l-.7-.7a.495.495 0 0 1 0-.701l3.504-3.505a.495.495 0 0 1 .7 0l3.505 3.505a.495.495 0 0 1 0 .7l-.701.701a.496.496 0 0 1-.7 0Z" class="wd-icon-fill"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" class="wd-icon-fill" clip-rule="evenodd"/></g></g></svg>',
    filename: 'wd-icon-arrow-circle.svg',
    category: 'Core',
    tags: ['direction', 'navigation', 'planning'],
};
export default icon;
